import { render } from "./Arrows.vue?vue&type=template&id=e89cbd86&scoped=true"
import script from "./Arrows.vue?vue&type=script&lang=ts"
export * from "./Arrows.vue?vue&type=script&lang=ts"

import "./Arrows.vue?vue&type=style&index=0&id=e89cbd86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e89cbd86"

export default script